import React from 'react';

import { useSelector } from 'react-redux';
import { Button, Dropdown } from '@hpstellar/core/visId';
import { Filters } from '@hpstellar/vis-icons';

export default ({ mobileProps, label, ...rest }) => {
    const isMobile = useSelector(state => state && state.ui && state.ui.customBreakpoints &&  ['xsmall', 'small', 'medium'].includes(state.ui.customBreakpoints.visId));
    const isMiniCartOpen = useSelector(state => state && state.headerFooter && state.headerFooter.popover === 'cartPreviewClassic' )
    const {
        className,
        options,
        onChange,
        defaultValue,
        gtmActions
    } = rest || {};

    const { label: mobileLabel, className: mobileClassName } = mobileProps || {};
    return isMobile ? (
        <Button
            variation='secondary'
            theme='dark'
            {...mobileProps || {}}
            className={`visIdMobileSortAndFilter${mobileClassName ? ' '+mobileClassName : ''}`}
            startIcon={<Filters size='s' style={{fill: 'black'}}/>}
        >
            { mobileLabel || 'Sort & Filter' }
        </Button>
    ) : (
        <Dropdown 
            label={label || 'Sort by'}
            className={`visIdSortDropdown${className ? ' ' + className : ''}${isMiniCartOpen ? ' visIdDropdownInactive' : ''}`}
            options={options}
            onChange={onChange}
            defaultValue={defaultValue}
            gtmActions={gtmActions}
            disablePortal
        />
    )
}